var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9173 15C12.9173 16.6108 11.6115 17.9167 10.0007 17.9167C8.38982 17.9167 7.08398 16.6108 7.08398 15",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0259 15.0007H3.97406C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L4.16667 11.2493V7.91732C4.16667 4.69566 6.77834 2.08398 10 2.08398C13.2217 2.08398 15.8333 4.69565 15.8333 7.91732V11.2493L17.0682 12.4842C17.3447 12.7607 17.5 13.1357 17.5 13.5266C17.5 14.3407 16.84 15.0007 16.0259 15.0007Z",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.19cc7e0edf7d7cab87d8746c92f43432.svg";
export { ForwardRef as ReactComponent };